import { Button, Card, CardContent, Modal } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { QrScanner } from 'react-qrcode-scanner-mi';

interface ScanQrCodeModalProps {
  isOpen: boolean;
  onScan: (result: string) => void;
  onClose: () => void;
}

export const ScanQrCodeModal: FunctionComponent<ScanQrCodeModalProps> = ({
  isOpen,
  onScan,
  onClose,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card>
          <CardContent>
            {isOpen ? (
              <div style={{ width: 300, height: 300 }}>
                <QrScanner
                  onScan={(data) => {
                    if (data) {
                      onScan(data);
                    }
                  }}
                />
              </div>
            ) : null}
            <Button variant="contained" onClick={onClose} sx={{ mt: 2 }}>
              Fermer
            </Button>
          </CardContent>
        </Card>
      </div>
    </Modal>
  );
};
